<section>
	<uc-heading headingTitle="University Information" />
	<div
		class="grid grid-cols-1 divide-y sm:divide-y-0 border-y sm:border-y-0 sm:gap-6 sm:grid-cols-2 xl:grid-cols-4"
	>
		<uc-university-information-card
			cardTitle="Total Students"
			[value]="totalStudents() | number: '' : 'en-GB'"
		>
			<uc-users-svg />
		</uc-university-information-card>
		<uc-university-information-card
			cardTitle="Students in Halls"
			[value]="studentsInHalls() | number: '' : 'en-GB'"
		>
			<uc-house-svg />
		</uc-university-information-card>
		<uc-university-information-card
			cardTitle="Full Time (%)"
			[value]="fullTime() + '%'"
		>
			<uc-clock-svg />
		</uc-university-information-card>
		<uc-university-information-card
			cardTitle="Avg Tariff Points"
			[value]="avgTariffPoints()"
		>
			<uc-academic-cap-svg />
		</uc-university-information-card>
	</div>
</section>
